/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable sort-keys */

import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalSearchListItem } from '../../models/global-search.model';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-global-search-section',
    styleUrls: ['global-search-section.component.scss'],
    templateUrl: 'global-search-section.component.html',
    standalone: false
})
export class GlobalSearchSectionComponent implements OnInit {
   @Input() items: GlobalSearchListItem[];

   @Input() sectionName: string;

   @Output() itemSelected = new EventEmitter();

   idPrefix!: string;

   constructor(private router: Router) {}

   ngOnInit(): void {
      this.idPrefix = this.sectionName.toLowerCase().replace(' ', '');
   }

   onClick(): void {
      this.itemSelected.emit();
   }
}
